/** Shared Chart.js zoom/pan config for time-series and histogram charts. */

export const CHART_ZOOM_HINT =
  "Drag to zoom a range · Shift+drag to pan · Scroll to zoom · Reset zoom to restore";

export function getChartZoomPluginConfig({
  mode = "x",
  onZoomComplete,
  onPanComplete,
} = {}) {
  return {
    pan: {
      enabled: true,
      mode,
      modifierKey: "shift",
      ...(typeof onPanComplete === "function" ? { onPanComplete } : {}),
    },
    zoom: {
      wheel: {
        enabled: true,
        speed: 0.08,
      },
      pinch: {
        enabled: true,
      },
      drag: {
        enabled: true,
        backgroundColor: "rgba(37, 99, 235, 0.12)",
        borderColor: "rgba(37, 99, 235, 0.5)",
        borderWidth: 1,
      },
      mode,
      ...(typeof onZoomComplete === "function" ? { onZoomComplete } : {}),
    },
    limits: {
      [mode]: { min: "original", max: "original" },
    },
  };
}

/** Merge zoom plugin settings into existing Chart.js options. */
export function mergeChartZoomOptions(options, zoomConfig = {}) {
  if (!options) return options;

  return {
    ...options,
    plugins: {
      ...(options.plugins ?? {}),
      zoom: getChartZoomPluginConfig(zoomConfig),
    },
  };
}

/** Visible category index range after zoom/pan (Chart.js category scale). */
export function getCategoryScaleVisibleIndexRange(chart) {
  const scale = chart?.scales?.x;
  const labels = chart?.data?.labels;
  if (!scale || !labels?.length) return null;

  let min = Number(scale.min);
  let max = Number(scale.max);
  if (!Number.isFinite(min)) min = 0;
  if (!Number.isFinite(max)) max = labels.length - 1;

  const startIndex = Math.max(0, Math.floor(min + 1e-9));
  const endIndex = Math.min(labels.length - 1, Math.ceil(max - 1e-9));
  if (startIndex > endIndex) return null;

  return {
    startIndex,
    endIndex,
    isFullView: startIndex <= 0 && endIndex >= labels.length - 1,
  };
}
